import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

// import styles from "../styles/Navbar.module.css";
import logo from "../images/img_vh/vh-logo.png";
import logoTxt from "../images/img_vh/vh-logo-txt.png";

interface NavbarProps {
	logoText: string;
}

const Navbar = ({ logoText }: NavbarProps) => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	return (
		<nav className="navbar" data-mobile={`${isMobile}`}>
			<div className="nav_content_wrapper" >
				<div className="logo" data-mobile={`${isMobile}`}>
					<Link to="/" className="logo_txt">
						<img src={`${!isMobile ? logo : logoTxt}`} alt="" />
					</Link>
				</div>

				{isMobile ? (
					<div className="mobile_menu">
						<button
							className="hamburger"
							onClick={() => setIsMenuOpen(!isMenuOpen)}
							aria-label="Toggle menu"
						// aria-label={`${styles.Toggle} ${styles.menu}`}
						>
							☰
						</button>

						{isMenuOpen && (
							<div className={`dropdown ${isMenuOpen ? "open" : ""}`}>
								{/* <div className={`${styles.dropdown} ${isMenuOpen ? styles.open : ""}`}> */}
								<NavLink
									to="/products"
									className={({ isActive }) => `city ${isActive ? "clicked" : ""}`}
									data-has="true"
									onClick={() => setIsMenuOpen(false)} // 메뉴 닫기
								>Metrotown</NavLink>
								<span className="city" title="Coming soon" data-has="false">Vancouver</span>
								<span className="city" title="Coming soon" data-has="false">Richmond</span>
								<Link
									to="/booking"
									className="btn_book_txt"
									onClick={() => setIsMenuOpen(false)}
								>Contact Us</Link>
							</div>
						)}
					</div>
				) : (
					<div className="tablet_menu content">
						{/* <div className="tablet_menu content"> */}
						<div className="region">
							<NavLink to="/products" className={({ isActive }) => `city ${isActive ? "clicked" : ""}`} data-has="true">Metrotown</NavLink>
							<span className="city" title="Coming soon" data-has="false">Vancouver</span>
							<span className="city" title="Coming soon" data-has="false">Richmond</span>
						</div>
						<div className="btn_book">
							<Link
								to="/booking"
								className="btn_book_txt"
							>Contact Us</Link>
						</div>
					</div>
				)}
			</div>
		</nav>
	);
};

export default Navbar;